import React from "react";
import InternshipDirectoryListing from "./listing";

export default function AbsorbedInternshipDirectory(props) {
  return (
    <InternshipDirectoryListing
      {...props}
      fetchType="absorbed"
      title="Directory of Internships Absorbed"
      pageTitle="Directory of Internships Absorbed"
      dateLabel="Absorbed On"
      emptyMessage="No absorbed internships found"
    />
  );
}
